import { render, staticRenderFns } from "./SpouseEmergencyContact.vue?vue&type=template&id=1e5ca444&"
import script from "./SpouseEmergencyContact.vue?vue&type=script&lang=js&"
export * from "./SpouseEmergencyContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports